import { render, staticRenderFns } from "./Microcart.vue?vue&type=template&id=a57c7220&scoped=true&"
import script from "./Microcart.vue?vue&type=script&lang=js&"
export * from "./Microcart.vue?vue&type=script&lang=js&"
import style0 from "./Microcart.vue?vue&type=style&index=0&id=a57c7220&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a57c7220",
  null
  
)

export default component.exports